<template>
  <div
    class="box component-menu column-menu mini-menu df fdc jcc"
    @click="stopPropagation($event)"
    tabindex="0"
    @blur="$emit('close')"
    ref="content"
  >
    <span
      v-if="from=='component'"
      v-for="option in options1" :key="option.title"
      :disabled="option.disable"
      :class="{'disable-item': option.disable}"
      @click="$emit(option.emit)"
    >
      <p>
        <img :src="imgPath + option.icon" class="always-show" alt="">
        {{ option.title }}
      </p>
    </span>
    <hr v-if="from=='component'" class="hr1">
    <span v-for="option in options2" :key="option.title" @click="$emit(option.emit)">
      <p>
        <img :src="imgPath + option.icon" class="always-show" alt="">
        {{ option.title }}
      </p>
    </span>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'PricingEditBox',
  data () {
    return {
      imgPath: '/images/mini-menu-icons/'
    }
  },
  props: {
    item: {
      type: Object,
      default: null
    },
    from: {
      type: String,
      default: ''
    }
  },
  components: {
  },
  computed: {
    ...mapGetters([
      'userRole'
    ]),
    moduleColumns() {
      return this.$store.getters.currentProjectModuleColumns
    },
    options1() {
      if (this.item) {
        return [
          { title: 'Indent', icon: 'Indent-Icon.png', emit: 'indent', disable: this.item.indented && this.item.indented > 2 },
          { title: 'Outdent', icon: 'Outdent-Icon.png', emit: 'outdent', disable: !this.item.indented},
        ]
      }
      return []
    },
    options2() {
      if (this.from == 'module') {
        return [
          { title: 'Hide', icon: 'Hide-Icon.png', emit: 'hide' },
          { title: 'Delete', icon: 'Delete-Icon.png', emit: 'delete' }
        ]
      }
      return [
        { title: 'Edit', icon: 'Edit-Small.svg', emit: 'edit' },
        { title: this.item.disabled ? 'Enable' : 'Disable', icon: 'Disable-Icon.png', emit: 'enable' },
        { title: 'Hide', icon: 'Hide-Icon.png', emit: 'hide' },
        { title: 'Delete', icon: 'Delete-Icon.png', emit: 'delete' },
        { title: 'Duplicate', icon: 'Duplicate-Icon.png', emit: 'duplicate' },
        { title: 'Clear', icon: 'Clear-Icon.png', emit: 'clear' }
      ]
    }
  },
  methods: {
    stopPropagation (event) {
      event.stopPropagation()
    }
  },
  created () {
  },
  mounted() {
    this.$refs.content.focus()
  }
}
</script>
<style scoped lang="scss">
@import "../../../../styles/components/_pricingsheettop.scss";
.hr1 {
  height: 2px;
  border: 0px solid transparent;
  background-color: #ddd;
  width: 35px;
}
.disable-item {
  color: grey !important;
  p {
    color: #999999 !important;
  }
}

</style>
